import app from 'src/AspediaVueJSDrupalWebsite'
import routes from './routes.json'
import homepage from './components/homepage'
import fetch from 'cross-fetch'
import applogger from '@applogger'

if (process.env.SERVER_BUILD !== 'ssr') {
  window.applogger = applogger
  if (!window.fetch) window.fetch = fetch
}
else {
  global.applogger = applogger
  global.fetch = fetch
}

// AspediaVueJSDrupalWebsite.js already registered a regcallback (re-invoked
// by app.js's run() on every SSR request, after it resets this.routes -
// see run()'s reset comment). addRegistryCallback() is a plain overwrite,
// not a chain, so we capture and call the existing one first rather than
// replacing it - otherwise every route/component/preload item
// AspediaVueJSDrupalWebsite.js registers would vanish. Without this
// wrapping, addStartup/addRoutes below only ran once at module load,
// before run() ever reset this.routes for the first time - so "/" and
// /node/:nid were silently missing from the router on every request.
const existingRegCallback = app.regcallback
app.addRegistryCallback(function() {
  if (typeof existingRegCallback === 'function') {
    // .call(app), not a bare call - the original callback is a regular
    // (non-arrow) function that reads `this.ecommerceOptions` etc.,
    // expecting `this` to be the App instance the way app.js's run()
    // invokes it (`this.regcallback()`, method-style). A bare call here
    // would lose that binding and throw.
    existingRegCallback.call(app)
  }
  // Add our custom site home page.
  app.addStartup('homepage', homepage)
  // Add routes data.
  app.addRoutes(routes)
})

export {
  app
}
